import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable, Subject} from 'rxjs';
import {DoodOrderModel} from '@store/order/order.model';
import {DOOD_API} from '@config/ws.config';

export interface NeptingPreauthResponse {
  success: boolean;
  message?: string;
  authorization_id?: string;
  holder_receipt?: string[];
  token?: string;
}

export interface NeptingCaptureResponse {
  success: boolean;
  message?: string;
  holder_receipt?: string[];
  capture_planned?: boolean;
}


@Injectable({
  providedIn: 'root',
})
export class NeptingTerminalApiService {
  private readonly baseUrl = 'http://127.0.0.1:5000';

  private statusSubject = new Subject<string>();
  public status$: Observable<string> = this.statusSubject.asObservable();

  constructor(
    private readonly httpClient: HttpClient,
  ) {
  }

  abortTransaction$(): Observable<{ success: boolean; message: string }> {
    return this.httpClient.post<{ success: boolean; message: string }>(
      `${this.baseUrl}/abort`,
      {}
    );
  }

  transaction$(montant: number): Observable<NeptingPreauthResponse> {
    return this.httpClient.post<NeptingPreauthResponse>(`${this.baseUrl}/transaction`, {montant});
  }

  preAuthorize$(montant: number): Observable<NeptingPreauthResponse> {
    return this.httpClient.post<NeptingPreauthResponse>(`${this.baseUrl}/preauth`, {montant});
  }

  capture$(authorizationId: string, montant: number, token: string): Observable<NeptingCaptureResponse> {
    return this.httpClient.post<NeptingCaptureResponse>(`${this.baseUrl}/capture`, {
      authorization_id: authorizationId,
      montant,
      token
    });
  }

  getLastMessage$(): Observable<{ message: string }> {
    return this.httpClient.get<{ message: string }>(`${this.baseUrl}/message`);
  }

  changeOrderStatusToPayment$(orderId: string, paymentRef: string): Observable<DoodOrderModel> {
    return this.httpClient.post<DoodOrderModel>(`${DOOD_API}/payment-services/nepting/payment`, {
      order_id: orderId,
      terminal_payment_ref: paymentRef,
    });
  }
}
